export const shoppingCenters = {
    "features": [
        {
            "geometry": {
                "coordinates": [
                    -81.2356001,
                    28.6624735
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Oviedo Mall",
                "name": "Oviedo Mall"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.235081,
                    28.6575394
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Target",
                "name": "Target"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2255971,
                    28.6692725
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Publix Super Market at Tuscawilla Bend Shopping Center",
                "name": "Publix Super Market at Tuscawilla Bend Shopping Center"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2244982,
                    28.6697171
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Dragon City",
                "name": "Dragon City"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2249296,
                    28.6670117
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Sonic Drive-In",
                "name": "Sonic Drive-In"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2249628,
                    28.6651653
                ],
                "type": "Point"
            },
            "properties": {
                "description": "The Donut Patch",
                "name": "The Donut Patch"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2239305,
                    28.6549031
                ],
                "type": "Point"
            },
            "properties": {
                "description": "MISSION BBQ",
                "name": "MISSION BBQ"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2240288,
                    28.6578755
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Habaneros Mexican Grill Oviedo",
                "name": "Habaneros Mexican Grill Oviedo"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2096048,
                    28.65350579999999
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Sprouts Farmers Market",
                "name": "Sprouts Farmers Market"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2078811,
                    28.655307
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Chick-fil-A",
                "name": "Chick-fil-A"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2034047,
                    28.6740975
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Briskets BBQ Shack & Grill",
                "name": "Briskets BBQ Shack & Grill"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2029637,
                    28.6699917
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Knights Automotive",
                "name": "Knights Automotive"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2070744,
                    28.6692982
                ],
                "type": "Point"
            },
            "properties": {
                "description": "All Points Tile & Slate",
                "name": "All Points Tile & Slate"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.20624459999999,
                    28.6488446
                ],
                "type": "Point"
            },
            "properties": {
                "description": "The Jerk Grill",
                "name": "The Jerk Grill"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1776782,
                    28.6564284
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Winn-Dixie",
                "name": "Winn-Dixie"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.18081629999999,
                    28.6566027
                ],
                "type": "Point"
            },
            "properties": {
                "description": "McDonald's",
                "name": "McDonald's"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.20082719999999,
                    28.6564005
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Ford's Garage Oviedo",
                "name": "Ford's Garage Oviedo"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1754958,
                    28.6447723
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Twin Rivers Golf Club",
                "name": "Twin Rivers Golf Club"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2068602,
                    28.6714377
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Ace Hardware of Oviedo",
                "name": "Ace Hardware of Oviedo"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.201858,
                    28.6674037
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Oviedo Gymnasium/Aquatic Facility",
                "name": "Oviedo Gymnasium/Aquatic Facility"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1772127,
                    28.68046
                ],
                "type": "Point"
            },
            "properties": {
                "description": "The Tack Shack",
                "name": "The Tack Shack"
            },
            "type": "Feature"
        }
    ],
    "type": "FeatureCollection"
}







export const hospitals = {
    "features": [
        {
            "geometry": {
                "coordinates": [
                    -81.2230603,
                    28.6649277
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Family Tree Primary Care",
                "name": "Family Tree Primary Care"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.22018539999999,
                    28.6644867
                ],
                "type": "Point"
            },
            "properties": {
                "description": "A Comic Shop",
                "name": "A Comic Shop"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2200356,
                    28.6629075
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Laguna Clay Co. (Axner Pottery Supply)",
                "name": "Laguna Clay Co. (Axner Pottery Supply)"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.22809989999999,
                    28.6580005
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Oviedo Medical Center",
                "name": "Oviedo Medical Center"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1764293,
                    28.658652
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Innovative Dental and Orthodontics",
                "name": "Innovative Dental and Orthodontics"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1983789,
                    28.6519296
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Boston Cemetery",
                "name": "Boston Cemetery"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.201551,
                    28.6630898
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Your Oviedo Dentist",
                "name": "Your Oviedo Dentist"
            },
            "type": "Feature"
        }
    ],
    "type": "FeatureCollection"
}








export const schools = {
    "features": [
        {
            "geometry": {
                "coordinates": [
                    -81.2184785,
                    28.6725206
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Oviedo High School",
                "name": "Oviedo High School"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.19574829999999,
                    28.6679384
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Jackson Heights Middle School",
                "name": "Jackson Heights Middle School"
            },
            "type": "Feature"
        },
{
            "geometry": {
                "coordinates": [
                    -81.1779838,
                    28.625119
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Haggerty High School",
                "name": "Haggerty High School"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1907098,
                    28.6543885
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Stenstrom Elementary School",
                "name": "Stenstrom Elementary School"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1797368,
                    28.6519001
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Twin Rivers Montessori Academy",
                "name": "Twin Rivers Montessori Academy"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.18796119999999,
                    28.6574963
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Reformed Theological Seminary",
                "name": "Reformed Theological Seminary"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2340334,
                     28.6490569
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Master's Academy",
                "name": "Master's Academy"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1583545,
                    28.6539086
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Lawton Chiles Middle School",
                "name": "Lawton Chiles Middle School"
            },
            "type": "Feature"
        },
   {
            "geometry": {
                "coordinates": [
                    -81.1819267,
                    28.6256463
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Carillon Elementary School",
                "name": "Carillon Elementary School"
            },
            "type": "Feature"
        },
  {
            "geometry": {
                "coordinates": [
                    -81.2053947,
                    28.6417823
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Evans Elementary School",
                "name": "Evans Elementary School"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1561437,
                    28.6497772
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Partin Elementary School",
                "name": "Partin Elementary Schools"
            },
            "type": "Feature"
        },
   {
            "geometry": {
                "coordinates": [
                    -81.2354142,
                    28.6462327
                ],
                "type": "Point"
            },
            "properties": {
                "description": "St. Lukes Lutheran School",
                "name": "St. Lukes Lutheran School"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.170372,
                    28.6316162
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Seminole State College - Lee Campus at Oviedo",
                "name": "Seminole State College - Lee Campus at Oviedo"
            },
            "type": "Feature"
        }
    ],
    "type": "FeatureCollection"
}




export const parks = {
    "features": [
        {
            "geometry": {
                "coordinates": [
                    -81.2035989,
                    28.658581
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Oviedo on the Park",
                "name": "Oviedo on the Park"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1933871,
                    28.6578555
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Royalwood Park",
                "name": "Royalwood Park"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.16735782426784,
                    28.67956866576579
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Solary Park",
                "name": "Solary Park"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.19378999999999,
                    28.67199
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Round Lake Park",
                "name": "Round Lake Park"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.18698499999999,
                    28.66484699999999
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Long Lake Park",
                "name": "Long Lake Park"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2027621,
                    28.6585504
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Center Lake Park",
                "name": "Center Lake Park"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1851724,
                    28.6481064
                ],
                "type": "Point"
            },
            "properties": {
                "description": "River Woods Park",
                "name": "River Woods Park"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.2057662,
                    28.6784662
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Sweetwater Park",
                "name": "Sweetwater Park"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.21205979999999,
                    28.6698405
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Friendship Park",
                "name": "Friendship Park"
            },
            "type": "Feature"
        },
        {
            "geometry": {
                "coordinates": [
                    -81.1754679,
                    28.6751746
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Shane Kelly Bark Park",
                "name": "Shane Kelly Bark Park"
            },
            "type": "Feature"
        }
    ],
    "type": "FeatureCollection"
}




export const transports = {
    "features": [
        {
            "geometry": {
                "coordinates": [
                    -81.19024999999999,
                    28.67016
                ],
                "type": "Point"
            },
            "properties": {
                "description": "Mobil",
                "name": "Mobil"
            },
            "type": "Feature"
        }
    ],
    "type": "FeatureCollection"
}
